import { useEffect, useRef } from 'react';

/**
 * 조건에 따라 한 번만 함수를 호출하는 훅
 * @param callback - 호출될 함수
 * @param condition - 호출 조건 (true일 때만 실행)
 */
export const useOnceEffect = (
  callback: () => void,
  condition: boolean = true,
) => {
  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (!hasCalledRef.current && condition) {
      callback();
      hasCalledRef.current = true;
    }
  }, [callback, condition]);
};
